export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window
}

// iPhone/iPad Safari only delivers pushes to an installed (home screen) PWA.
export function needsIosInstall() {
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent)
  return ios && window.navigator.standalone !== true
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = window.atob(base64)
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)))
}

// Resolves to a PushSubscription, or null if the user denied permission.
export async function subscribeToPush(vapidPublicKey) {
  const registration = await navigator.serviceWorker.ready
  const permission = await Notification.requestPermission()
  if (permission !== 'granted') return null
  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  })
}

async function api(method, path, body) {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content
  const res = await fetch(path, {
    method,
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
    body: body ? JSON.stringify(body) : undefined,
  })
  if (!res.ok) throw new Error(`push api ${res.status}`)
  return res.json()
}

export const followTeam = (subscription, teamId) =>
  api('POST', '/push/follows', { subscription: subscription.toJSON(), team_id: teamId })

export const unfollowTeam = (endpoint, teamId) =>
  api('DELETE', `/push/follows/${teamId}`, { endpoint })

export const fetchFollows = (endpoint) =>
  api('GET', `/push/follows?endpoint=${encodeURIComponent(endpoint)}`)
